var _circle, _circle2, _circle3, _circle4, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircles2Product(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 541,
    viewBox: "0 0 302 541",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 85.5 166.5)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 187.5 305.5)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 244,
    r: 87.5,
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 144.5,
    r: 177,
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_499_103",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7499 440.526C65.3337 453.661 75.4306 465.175 87.464 474.408C99.4973 483.642 113.232 490.415 127.882 494.34C142.533 498.266 157.814 499.267 172.852 497.288C187.89 495.308 202.391 490.385 215.526 482.802L189.227 437.25C182.073 441.38 174.176 444.061 165.986 445.139C157.797 446.217 149.475 445.672 141.496 443.534C133.517 441.396 126.037 437.707 119.484 432.679C112.931 427.65 107.432 421.38 103.302 414.226L57.7499 440.526Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7499 440.526C65.3337 453.661 75.4306 465.175 87.464 474.408C99.4973 483.642 113.232 490.415 127.882 494.34C142.533 498.266 157.814 499.267 172.852 497.288C187.89 495.308 202.391 490.385 215.526 482.802L189.227 437.25C182.073 441.38 174.176 444.061 165.986 445.139C157.797 446.217 149.475 445.672 141.496 443.534C133.517 441.396 126.037 437.707 119.484 432.679C112.931 427.65 107.432 421.38 103.302 414.226L57.7499 440.526Z",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-5-inside-1_499_103)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles2Product);
export default __webpack_public_path__ + "static/media/circles2_product.15f7f261bde2863410c5ec72cdfac9bb.svg";
export { ForwardRef as ReactComponent };